import axios from 'axios'

import { emitter } from '@/lib/emmiter'
import { getTokens } from '@/services/token-storage'

const apiBf = axios.create({
  baseURL: import.meta.env.VITE_API_BF_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiBf.interceptors.request.use(
  (config) => {
    const { tokenBf } = getTokens()

    if (tokenBf) {
      config.headers.Authorization = `Bearer ${tokenBf}`
    }

    return config
  },
  (error) => Promise.reject(error),
)

apiBf.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const showUnauthorizedDialog =
        error.response.config.url !== 'api/auth/logout' &&
        !window.location.href.includes('login-token')

      emitter.emit('show-unauthorized-dialog', {
        value: showUnauthorizedDialog,
        shouldInvalidateToken: false,
      })
    }
    return Promise.reject(error)
  },
)

export { apiBf }
